import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import AutoTable from 'components/AutoTable'
import { Alert } from 'reactstrap'

const SitesResultsGrid = ({ sites }) => {
  const columns = [
    {
      title: 'Site Name',
      fieldValue: 'name',
    },
    {
      title: 'NetSuite Customer Id',
      fieldValue: 'netSuiteCustomer.nsCustomerId',
    },
    {
      title: 'Organization Name',
      fieldValue: 'organization.name',
    },
    {
      title: 'Organization Id',
      fieldValue: 'organization.id',
    },
    {
      title: 'Site Id',
      fieldValue: row => {
        return <Link to={`/css-admin/sites/${row.id}`}>{row.id}</Link>
      },
      sortValue: 'id',
      filterValue: 'id',
    },
  ]

  return sites.length ? (
    <AutoTable
      borderless
      columns={columns}
      filter
      headThemeLight
      rows={sites}
      sort
    />
  ) : (
    <Alert color="warning">No results found</Alert>
  )
}

SitesResultsGrid.propTypes = {
  sites: PropTypes.arrayOf(PropTypes.object),
}

SitesResultsGrid.defaultProps = {
  sites: [],
}

export default SitesResultsGrid



// WEBPACK FOOTER //
// ./src/components/SitesResultsGrid/component.js